/**
 * @flow
 * @relayHash 8047ce0154317c9cd36ae9489b7ada2e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type InfoStringEdit_viewer$ref = any;
export type queries_infoStringEditFormQueryVariables = {|
  id: string
|};
export type queries_infoStringEditFormQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: InfoStringEdit_viewer$ref
  |}
|};
export type queries_infoStringEditFormQuery = {|
  variables: queries_infoStringEditFormQueryVariables,
  response: queries_infoStringEditFormQueryResponse,
|};
*/


/*
query queries_infoStringEditFormQuery(
  $id: ID!
) {
  viewer {
    ...InfoStringEdit_viewer_1Bmzm5
    id
  }
}

fragment InfoStringEdit_viewer_1Bmzm5 on Viewer {
  id
  infoString(id: $id) {
    id
    title
    order
    infostring
    infostring_hot
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_infoStringEditFormQuery",
  "id": null,
  "text": "query queries_infoStringEditFormQuery(\n  $id: ID!\n) {\n  viewer {\n    ...InfoStringEdit_viewer_1Bmzm5\n    id\n  }\n}\n\nfragment InfoStringEdit_viewer_1Bmzm5 on Viewer {\n  id\n  infoString(id: $id) {\n    id\n    title\n    order\n    infostring\n    infostring_hot\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_infoStringEditFormQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "InfoStringEdit_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_infoStringEditFormQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "infoString",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": "ID"
              }
            ],
            "concreteType": "InfoString",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "order",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "infostring",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "infostring_hot",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '08c82ea99f68ca9ae261393d3fcfada7';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_infoStringEditFormQuery.graphql.js